export interface initiativeState {
  combatants: Array<any>;
}

export default {
  namespaced: true,
  state: (): initiativeState => ({
    combatants: [],
  }),
  getters: {
    combatants: (state: initiativeState) => {
      return state.combatants;
    },
    newId: (state: initiativeState) => {
      if (state.combatants.length === 0) {
        return 0;
      }
      state.combatants.sort((a, b) => a.id - b.id);
      return state.combatants[state.combatants.length - 1].id + 1;
    },
  },
  mutations: {
    setCombatants: (state: initiativeState, newData: Array<string>) => {
      state.combatants = newData;
    },
    addCombatants: (
      state: initiativeState,
      newData: { name: string; initiative: number; id: number }
    ) => {
      state.combatants.push(newData);
    },
    removeCombatant: (state: initiativeState, id: number) => {
      for (let i = 0; i < state.combatants.length; i++) {
        if (state.combatants[i].id === id) {
          state.combatants.splice(i, 1);
        }
      }
    },
    editCombatant: (
      state: initiativeState,
      newData: { name: string; initiative: number; id: number }
    ) => {
      for (let i = 0; i < state.combatants.length; i++) {
        if (state.combatants[i].id === newData.id) {
          state.combatants[i].name = newData.name;
          state.combatants[i].initiative = newData.initiative;
        }
      }
    },
  },
};
